import {Controller} from "@hotwired/stimulus"

const MAX_FILESIZE_MB = 10

// Dropzone is the Sprockets global from vendor/assets/javascripts/dropzone; this bundle does not import it.
export default class extends Controller {
  static values = {paramName: String, message: String, acceptedFiles: String, singleFile: Boolean}

  connect() {
    // Not in the markup: Dropzone auto-discovers `.dropzone` forms on page load with default options.
    this.element.classList.add("dropzone")
    this.dropzone = new window.Dropzone(this.element, this.dropzoneOptions)
    if (this.singleFileValue) this.dropzone.on("maxfilesexceeded", (file) => this.replaceFile(file))
  }

  disconnect() {
    this.dropzone.destroy()
  }

  get dropzoneOptions() {
    return {
      paramName: this.paramNameValue,
      dictDefaultMessage: this.messageValue,
      maxFilesize: MAX_FILESIZE_MB,
      ...(this.hasAcceptedFilesValue && {acceptedFiles: this.acceptedFilesValue}),
      ...(this.singleFileValue && {maxFiles: 1}),
    }
  }

  replaceFile(file) {
    this.dropzone.removeAllFiles()
    this.dropzone.addFile(file)
  }
}
